var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contnav"},[_c('div',{staticClass:"nav_back"},[_c('img',{attrs:{"src":_vm.user.noimg,"alt":""}}),_c('p',[_vm._v("流静冥想")]),_c('p',[_vm._v("带你探索内心的宁静与力量")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }